import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import {environment} from '../../environments/environment';
import {Title} from '../../../shared/dto/title/title';

@Injectable({
	providedIn: 'root'
})

export class AccountService {

	constructor(private http: HttpClient) {
	}

	getAccount() {
		return this.http.get<any>(environment.financialUrl + '/account/getActive');
	}

	getProducts(){
		return this.http.get<any>(environment.financialUrl + '/account/products');
	}

}
